// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + (chunkId === 101 ? "battle" : chunkId) + "." + {"101":"82a8abec","130":"39ba1444","179":"d8ba6223"}[chunkId] + ".js";
};